// Shared badge/indicator colors used by dots, status pills, and slider highlight gradients. Kept centralized so badge dots and slider gradients stay visually consistent.
export const BADGE_COLOR = {
  green: "#35a02b",
  greenLight: "#7fd87a",
  red: "#df4754",
  yellow: "#f5b614",
  grayNeutral: "#e5e7eb",
} as const;
